import React, { useId } from "react";

import { SlidingCardBlock, SlidingCardsBlock as Value } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { MediaChooserBlock } from "../MediaChooserBlock";

import styles from "./index.module.scss";

const SlidingCard = ({ title, media, columns }: SlidingCardBlock) => {
    const id = useId();

    return (
        <div className={styles.card}>
            {media && media.length > 0 ? (
                <MediaChooserBlock
                    wrapperAttrs={{ className: styles.cardMedia }}
                    value={media}
                    type="background"
                />
            ) : null}
            <div className={styles.cardContent}>
                <h3 className={styles.cardTitle}>{title}</h3>
                {columns && columns.length > 0 && (
                    <div className={styles.cardColumns}>
                        <div className={styles.cardColumnsInner}>
                            {columns.map(({ title, subtitle }, index) => (
                                <div
                                    key={`${id}-${index}`}
                                    className={concatClassNames([
                                        styles.cardColumn,
                                        columns.length === 1
                                            ? styles.cardColumnSingle
                                            : undefined,
                                    ])}
                                >
                                    {title && (
                                        <h4 className={styles.cardColumnTitle}>
                                            {title}
                                        </h4>
                                    )}
                                    {subtitle && <p>{subtitle}</p>}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

interface Props {
    value: Value;
}

export const SlidingCardsBlock = ({ value: { theme, cards } }: Props) => {
    const id = useId();
    if (!cards) return <></>;

    return (
        <section className={styles[theme ?? "match"]}>
            <div className={styles.grid}>
                {cards.map((card, index) => (
                    <SlidingCard key={`${id}-${index}`} {...card} />
                ))}
            </div>
        </section>
    );
};
